/* eslint-disable import/max-dependencies */
import { Container } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import type { Dispatch } from "redux";
import { bindActionCreators } from "redux";
import debounce from "lodash.debounce";
import { Loader } from "@fas/ui-core";
import { getErrors } from "@fas/ui-framework";
import {
  getLinkingInfoSaga,
  setLinkingInfoName,
  setLinkingInfoType,
  setLinkingInfoTagsGeneration,
  setLinkingInfoTagsDisplay,
  setLinkingInfoTemplateCode,
  setLinkingInfoUsePagination,
} from "../../../actions/linkingList";
import { GeneralInfo as GeneralInfoForm } from "../../../components/LinkingInfoForm";
import { setBackup, restoreBackup } from "../../../actions/backup";
import {
  getName as getLinkingName,
  getType as getLinkingType,
  getTagsGeneration,
  getTagsDisplay,
  getTemplateCode,
  getLinkingInfoUsePagination,
} from "../../../selectors/linking";
import {
  getIsLinkedItemLoading,
  getIsAccountModulesLoading,
} from "../../../selectors/loading";
import { getAccountsModulesSaga } from "../../../actions/accountModules";
import { getLinkingTypes } from "../../../selectors/accountModules";
import { linkingBackupStore } from "../../../pages/AppStoreWrapper/store";
import type { State } from "../../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/GeneralInfo.type";
import type { Types } from "../../../components/LinkingInfoForm/types/LinkingInfoForm.types";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  name: getLinkingName(state),
  type: getLinkingType(state),
  tagsGeneration: getTagsGeneration(state),
  tagsDisplay: getTagsDisplay(state),
  templateCode: getTemplateCode(state),
  errors: getErrors(state),
  linkedInfoLoading: getIsLinkedItemLoading(state),
  accountModulesLoading: getIsAccountModulesLoading(state),
  linkingTypes: getLinkingTypes(state),
  usePagination: getLinkingInfoUsePagination(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    getLinkingInfo: getLinkingInfoSaga,
    onNameChange: setLinkingInfoName,
    onTypeChange: setLinkingInfoType,
    onTagsGenerationChange: setLinkingInfoTagsGeneration,
    onTagsDisplayChange: setLinkingInfoTagsDisplay,
    onTemplateCodeChange: setLinkingInfoTemplateCode,
    getAccountModules: getAccountsModulesSaga,
    onUsePaginationChange: setLinkingInfoUsePagination,
    onSetBackup: setBackup,
    onRestoreBackup: restoreBackup,
  }, dispatch),
});

function GeneralInfo({
  errors,
  getLinkingInfo,
  linkedInfoLoading,
  accountModulesLoading,
  name,
  onNameChange,
  onTagsDisplayChange,
  onTagsGenerationChange,
  onTemplateCodeChange,
  onTypeChange,
  tagsDisplay,
  tagsGeneration,
  templateCode,
  usePagination,
  onUsePaginationChange,
  type,
  linkingTypes,
  onSetBackup,
  onRestoreBackup,
}: Props) {
  const { id } = useParams<{ id?: string }>();

  useEffect(() => {
    onSetBackup(linkingBackupStore);
    if (id) getLinkingInfo(id);
    return () => {
      onRestoreBackup();
    };
  }, [getLinkingInfo, id]);

  const debouncedCodeEditorChange = debounce(onTemplateCodeChange, 600);
  const handleCodeEditorChange = (value: string) => {
    debouncedCodeEditorChange(value);
  };

  return (
    <Container>
      <Loader loading={linkedInfoLoading || accountModulesLoading}>
        <GeneralInfoForm
          name={name}
          type={type}
          tagsGeneration={tagsGeneration}
          tagsDisplay={tagsDisplay}
          templateCode={templateCode}
          onNameChange={onNameChange}
          onTypeChange={onTypeChange}
          onTagsDisplayChange={onTagsDisplayChange}
          onTagsGenerationChange={onTagsGenerationChange}
          onTemplateCodeChange={handleCodeEditorChange}     
          errors={errors.toJS()}
          types={linkingTypes}
          usePagination={usePagination}
          onUsePaginationChange={onUsePaginationChange}
        />
      </Loader>
    </Container>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInfo as any);
